import styled from "styled-components"
import Colors from "../../theme/Colors"
import { notPhone } from "../../theme/MediaQueries"

export const ArrowDown = styled.div`
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 10px solid ${props => props.color};
`

export const WidgetTitleContainer = styled.div`
  background-color: ${Colors.lightestgrey};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 8px 16px;
  ${notPhone} {
    padding: 16px 0;
    width: 100%;
  }
`

export const AddonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
`
